import React, {FC} from 'react'
import {Link, useParams} from 'react-router-dom'
import {publicJobApplyPath} from '../../hr/job/JobModel'
import {PublicLoading, PublicNotFound} from '../components/PublicState'
import {PublicJobLayout} from './PublicJobLayout'
import {usePublicJob} from './usePublicJob'

/**
 * Giriş gerektirmeyen ilan sayfası (/jobs/:id).
 * Yalnızca yayındaki (ACTIVE) ilanlar açılır; "Başvur" başvuru formuna götürür.
 */
const PublicJobPage: FC = () => {
  const {id} = useParams<{id: string}>()
  const {job, company, state} = usePublicJob(id)

  if (state === 'loading') return <PublicLoading />
  if (state === 'notFound' || !job || !company) {
    return (
      <PublicNotFound
        title='İlan bulunamadı'
        description='Bu ilan yayından kaldırılmış ya da bağlantı hatalı olabilir.'
      />
    )
  }

  return (
    <PublicJobLayout
      job={job}
      company={company}
      aside={
        <div className='pc-aside'>
          <div className='pc-aside-title'>Başvuru</div>
          <div className='pc-aside-text'>
            Bu pozisyona başvurmak için formu doldurun ve işe alım sürecinizi başlatın.
          </div>
          <Link to={publicJobApplyPath(job.id)} className='pc-btn-primary d-block text-center'>
            Başvur
          </Link>
        </div>
      }
    />
  )
}

export {PublicJobPage}
